import { OnTapListener } from '@strava/mre';

/*
 * All of the properties on the OnTapListener interface are required.
 * Wasm/Emscripten is not very good at optional properties.
 * This utility function allows us to easily create listeners without needing to define
 * a load of noops.
 */
export const buildOnTapListener: (
  listener: Partial<OnTapListener>
) => OnTapListener = (listener) => {
  const noop = () => undefined;

  return {
    onContentTap: noop,
    onMapTap: noop,
    onUserMarkerTap: noop,
    onLongContentTap: noop,
    onLongMapTap: noop,
    onLongUserMarkerTap: noop,
    // properties of listener will override the noops declared above
    ...listener
  };
};
